function formatFuelData(name: string) {
  let fuelData = {
    name: '',
    flag: '',
    bgColor: '',
  };
  switch (name.toLowerCase().trim()) {
    case 'gasolina comum':
      fuelData = {
        name: 'Gasolina Comum',
        flag: 'G',
        bgColor: '#F1B04C',
      };
      break;
    case 'gasolina aditivada':
      fuelData = {
        name: 'Gasolina Aditivada',
        flag: 'G',
        bgColor: '#1576f4',
      };
      break;
    case 'etanol':
      fuelData = {
        name: 'Etanol',
        flag: 'E',
        bgColor: '#00A651'
      };
      break;
    case 'diesel comum':
      fuelData = {
        name: 'Diesel Comum',
        flag: 'D',
        bgColor: '#6B7280',
      };
      break;
    case 'diesel s10':
      fuelData = {
        name: 'Diesel S10',
        flag: 'D',
        bgColor: '#5B6C8F',
      };
      break;
    case 'gasolina podium':
      fuelData = {
        name: 'Gasolina Podium',
        flag: 'G',
        bgColor: '#1E5EFF',
      };
      break;
    case 'etanol aditivado':
      fuelData = {
        name: 'Etanol Ad.',
        flag: 'E',
        bgColor: '#1DBF73',
      };
      break;
    default:
      fuelData = {
        name,
        flag: '',
        bgColor: '#03b3a1',
      };
  }

  return fuelData;
}

export default formatFuelData;
